import script from "./delete-election-button.vue?vue&type=script&lang=js"
export * from "./delete-election-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__